import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';


//STYLES
import './BarApp.css';

//BACKGROUND IMG
import backImg from '../assets/imgs/back24-25.png'

//COMPONENTS
import PassGenerator from '../components/misc/PassGenerator';
import Home from '../pages/bar/home/Home'
import TaskDetail from '../pages/bar/task/TaskDetail';
import Category from '../pages/bar/category/Category';
import Search from '../pages/bar/search/Search';
import Header from '../components/bar/Header';
import Contact from '../pages/bar/contact/Contact';
import Footer from '../components/bar/Footer';
import { useData } from '../hooks/useData';

function BarApp() {
  const { data: cat } = useData('CATEGORIES')
  const { data: rawTasks } = useData('TASKS')

  const [tasks, setTasks] = useState(null)

  useEffect( () => {
    if (rawTasks) {
      rawTasks.sort((t1, t2) => {
        if (t1.order < t2.order) {
          return -1
        } else if (t1.order > t2.order) {
          return 1
        }
        return 0
      })
      setTasks(rawTasks.map( t => {
        return{...t, completed: false}
      }))
    }
  },[rawTasks])

  return (
    <div className="App">
      <BrowserRouter>
        <Header/>
        <div className='main-content' style={{backgroundImage: `url(${backImg})`}}>
          <Routes>
            <Route path='/' element={<Home categories={cat}/>}/>
            <Route path='/pass' element={<PassGenerator/>}/>
            <Route path='/contact' element={<Contact/>}/>
            <Route 
              path='/task/:id' 
              element={
                <TaskDetail 
                  tasks={tasks} 
                  setTasks={setTasks}
                />
              }
            />
            <Route 
              path='/cat/:id' 
              element={
                <Category 
                  tasks={tasks} 
                  categories={cat} 
                  setTasks={setTasks}
                />
              }
            />
            <Route 
              path='/search' 
              element={
                <Search 
                  tasks={tasks}
                  cat={cat}
                />
              }
            />
          </Routes>
        </div>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default BarApp;
